import React, { useState } from "react";
import { t } from "i18next";

import { ICTA, ICTAButton, ICTAOptions, ICTAText } from "../../../interfaces/event/cta"
import { breakpointSize } from "../../../theme/mediaQuerie";

import BaseToggle from "../../shared/BaseToggle";
import InputColorPicker from "../../shared/inputColorPicker/InputColorPicker";
import PageTitle from "../../shared/pageTitle/PageTitle";
import Input from "../../shared/input/Input";

import { Label } from "../../shared-v2/Label";
import { TextArea } from "../../shared-v2/TextArea";
import { Subtitle } from "../../shared-v2/Subtitle";
import { IFile, UploadImage } from "../../shared-v2/UploadImage";
import { TextActions } from "../../shared-v2/TextActions";
import { AlignActions } from "../../shared-v2/AlignActions";

import { Row, RowGrid, Column, InputGroup, ToggleContainer } from "./style";
import Typography from "../../shared/typography/Typography";

interface IProps {
  cta: ICTA;
  setCta: React.Dispatch<React.SetStateAction<ICTA>>;
}

const isMobile = window.innerWidth <= breakpointSize.Sm;

export const CTA = ({cta, setCta}: IProps) => {
  const [file, setFile] = useState<IFile | null>(null);

  const updateCTA = (attr: keyof ICTA, value: boolean) => {
    setCta(prev => ({...prev, [attr]: value}));
  }

  const updateOptions = (attr: keyof ICTAOptions, value: string) => {
    setCta(prev => ({...prev, options: { itens: {...prev.options.itens, [attr]: value}}}));
  }

  const updateText = (attr: keyof ICTAText, value: string) => {
    setCta(prev => ({...prev, options: { itens: {...prev.options.itens, 
      text: {...prev.options.itens.text, [attr]: value}}}}));
  }

  const updateButton = (attr: keyof ICTAButton, value: string | boolean) => {
    setCta(prev => ({...prev, options: { itens: {...prev.options.itens, 
      button: {...prev.options.itens.button, [attr]: value}}}}));
  }

  return (
    <>
     <Row>
        { !isMobile && <PageTitle style={{margin: 0}} >{t("dashboard.event.CTA.title")}</PageTitle> }
        <ToggleContainer>
          <Typography type="paragraphS" color="title">{t("dashboard.event.displaySection")}</Typography>
          <BaseToggle
            initialCheck={cta.menu ?? false} 
            onChange={(checked: boolean) => updateCTA("menu", checked)} 
          />
        </ToggleContainer>
      </Row>

      <RowGrid >
        <Column>
          <Row>
            <Label>{t("title")}</Label>
            <TextActions 
              menuDisplayMode={!isMobile}
              setTextAlign={(value) => updateText("align", value)}
              textAlign={cta.options.itens.text.align} 
            />
            {!isMobile && (
              <AlignActions 
                menuDisplayMode={!isMobile}
                alignX={cta.options.itens.positionX} 
                setAlignX={(value) => updateOptions("positionX", value)} 
                alignY={cta.options.itens.positionY} 
                setAlignY={(value) => updateOptions("positionY", value)} 
              />
            )}
          </Row>
          <TextArea 
            positionX={cta.options.itens.positionX}  
            positionY={cta.options.itens.positionY}
            maxLength={50} 
            textAlign={cta.options.itens.text.align} 
            value={cta.options.itens.text.title} 
            onChange={(e) => updateText("title", e.target.value)}
          />
        </Column>
        <Column>
          <Label>{t("description")}</Label>
          <TextArea 
            positionX={cta.options.itens.positionX}  
            positionY={cta.options.itens.positionY}
            maxLength={50} 
            textAlign={cta.options.itens.text.align} 
            value={cta.options.itens.text.description} 
            onChange={(e) => updateText("description", e.target.value)} 
          />
          {isMobile && (
            <AlignActions
              menuDisplayMode={!isMobile}
              alignX={cta.options.itens.positionX} 
              setAlignX={(value) => updateOptions("positionX", value)} 
              alignY={cta.options.itens.positionY} 
              setAlignY={(value) => updateOptions("positionY", value)} 
            />
          )}
        </Column>
      </RowGrid>

      <Subtitle>{t("button")}</Subtitle>

      <RowGrid>
        <InputGroup>
          {!isMobile && <Label>{t("title")}</Label>}
          <Input 
            placeholder={t("title")!}
            value={cta.options.itens.button.title}  
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => updateButton("title", e.target.value)}
          />
        </InputGroup>
        <InputGroup>
         {!isMobile && <Label>{t("textColor")}</Label>}
          <InputColorPicker 
            color={cta.options.itens.button.color ?? "#000"}  
            handleChangeColor={(e) => updateButton("color", e.hex)}
          />
        </InputGroup>
        <InputGroup>
          {!isMobile && <Label>{t("buttonColor")}</Label>}
          <InputColorPicker 
            color={cta.options.itens.button.backgroudColor ?? "#fff"}  
            handleChangeColor={(e) => updateButton("backgroudColor", e.hex)}
          />
        </InputGroup>
      </RowGrid>

      <RowGrid>
        <UploadImage 
          file={file} 
          setFile={(file) => {updateOptions("backgroudImage", file?.url ?? ""); setFile(file);}} 
          id="cta-upload-image" 
          maxImageSize={1024 * 1024 * 10} 
          title={t("image")} 
        />
        {!isMobile && <div/>}
      </RowGrid>
    </>
  );
}